/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import AutoComplete from '../BaseComponent/autocomplete'

class ProductOfDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',

      providers: [],
      providerId: '',
      provider: {}
    }
  }
  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {
    //     if (response.data.error == null) {
    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] ='شناسه :' + result[i].providerId + '-' + result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getProductOfDriver() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId
    let providerName = this.state.provider.title
    if (providerId === '') {
      message.error('تامین کننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/products/driver/invoice?providerId=${providerId}&providerName=${providerName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  getDriverOfProduct() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId
    let providerName = this.state.provider.title
    if (providerId === '') {
      message.error('تامین کننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/products/invoice?providerId=${providerId}&providerName=${providerName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  getStationProduct() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId
    let providerName = this.state.provider.title
    if (providerId === '') {
      message.error('تامین کننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/products/invoice/cart?providerId=${providerId}&providerName=${providerName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  productOfDriver() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId
    let providerName = this.state.provider.title
    if (providerId === '') {
      message.error('تامین کننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/products/driver?providerId=${providerId}&providerName=${providerName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  driverOfProduct() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId
    let providerName = this.state.provider.title
    if (providerId === '') {
      message.error('تامین کننده را وارد کنید')
    } else if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/products?providerId=${providerId}&providerName=${providerName}&fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش کالای راننده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش کالای راننده</p>
            </div>

            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ تحویل به مشتری از"
              toLabel="تاریخ تحویل به مشتری تا"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />
            <div className="formComponent">
              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
                selected={(provider) => this.setState({provider})}
                required
              />
              {/* <label className='font-weight-bold'>
                                تامین کننده :‌
                                <span className='requireFiled'>*</span></label>
                            <Select
                                value={selectedOption}
                                onChange={this.handleChange}
                                options={this.state.providers}
                                isMulti={false}
                                isClearable={true}
                                placeholder={''}
                                id="input_supplierName"
                                name="input_supplierName"
                                tabIndex='1'
                            /> */}
            </div>
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.driverOfProduct.bind(this)}>
                گزارش کالاهای رساننده
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getStationProduct.bind(this)}>
                {' '}
                گزارش کالای جایگاه به تفکیک فاکتور
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getDriverOfProduct.bind(this)}>
                {' '}
                گزارش کالای رساننده به تفکیک فاکتور
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.productOfDriver.bind(this)}>
                گزارش رساننده های کالا
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getProductOfDriver.bind(this)}>
                گزارش رساننده های کالا به تفکیک فاکتور
              </button>

              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ProductOfDriver
